/**
 * Dove atterra chi entra, secondo cio' che gli e' permesso.
 *
 * Sta in un modulo suo e non nell'instradamento perche' la risposta serve in
 * due posti: all'instradamento, per portare la persona da qualche parte dopo
 * l'accesso, e allo scheletro della Carta, per sapere se la schermata che si
 * sta guardando **e' quella d'arrivo** — cioe' se e' il posto dove ha senso
 * dire a chi entra chi e' e che cosa fa. Chiedere l'una all'altro le farebbe
 * importare a vicenda.
 *
 * L'ordine non e' arbitrario: si atterra sul mestiere piu' vicino al lavoro
 * vero che quella persona puo' fare.
 */
import * as auth from './auth'
import type { Whoami } from './auth'

export function defaultPathFor(who: Whoami | null): string | null {
  if (who === null) return '/login'
  if (who.must_change_password) return '/password/change'
  if (who.may.includes(auth.INSPECTION_POOL_READ)) return '/work'
  if (who.may.includes(auth.PACKAGE_UPLOAD)) return '/uploads/new'
  if (who.may.includes(auth.USER_MANAGE)) return '/admin/users'
  if (who.may.includes(auth.MODEL_MANAGE)) return '/admin/model'
  if (who.may.includes(auth.SETTINGS_MANAGE)) return '/admin/settings'
  if (who.may.includes(auth.CATALOG_IMPORT)) return '/admin/catalog'
  if (who.may.includes(auth.AUDIT_READ)) return '/admin/audit'
  return null
}
